/**
 * 订单API模块
 * 提供订单相关的API调用功能
 */

// 防止重复声明 - 只在实例不存在时创建
if (window.orderAPI) {
  console.warn('orderAPI already exists, skipping redeclaration');
} else {

class OrderAPI {
  constructor() {
    this.baseURL = window.API_BASE_URL;
    this.ACCESS_TOKEN_KEY = 'accessToken';
    this.REFRESH_TOKEN_KEY = 'refreshToken';
  }

  /**
   * 从 cookie 获取 accessToken
   * @returns {string} accessToken
   */
  getAccessToken() {
    return this._getFromCookie(this.ACCESS_TOKEN_KEY);
  }

  /**
   * 从 cookie 获取 refreshToken
   * @returns {string} refreshToken
   */
  getRefreshToken() {
    return this._getFromCookie(this.REFRESH_TOKEN_KEY);
  }

  /**
   * 通用的 cookie 获取方法
   * @param {string} key - cookie 键名
   * @returns {string} cookie 值
   */
  _getFromCookie(key) {
    try {
      const cookies = document.cookie.split(';');
      for (let cookie of cookies) {
        const [name, value] = cookie.trim().split('=');
        if (name === key) {
          return value || '';
        }
      }
      return '';
    } catch (error) {
      return '';
    }
  }

  /**
   * 锁单
   * @param {string|number} orderId - 订单ID
   * @returns {Promise<Object>} 返回后端原始响应对象
   */
  async lockOrder(orderId) {
    const accessToken = this.getAccessToken();
    const refreshToken = this.getRefreshToken();

    if (!accessToken) {
      return { code: 0, message: 'Not logged in' };
    }

    if (!orderId) {
      return { code: 0, message: 'Order ID is required' };
    }

    // 使用 FormData 格式
    const formData = new FormData();
    formData.append('orderId', orderId);

    const response = await fetch(`${this.baseURL}/user/api/order/lock`, {
      method: 'PUT',
      headers: {
        'Authorization': `Bearer ${accessToken}`,
        'X-Client-Type': 'web',
        'Refresh-token': refreshToken,
      },
      body: formData
    }).catch(error => null);

    if (!response) {
      return { code: 0, message: 'Network error, please check your connection' };
    }

    const result = await response.json().catch(() => null);

    if (!result) {
      return { code: 0, message: 'Invalid response format' };
    }

    // 直接返回后端原始响应对象
    return result;
  }
}

// 创建全局实例
window.orderAPI = new OrderAPI();

}

